/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  notification,
  DatePicker,
  Select,
  Radio,
} from 'antd';
import { X } from 'lucide-react';
import moment from 'moment';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { getPopupContainerBody } from './ShippingManagement/shipmentFieldOptions';
import './DSR/DownTimeModal.css';
import '../pages/dashboard/DashboardPage.css';
import './GenerateReport.css';
const { Option } = Select;

const DATE_DROPDOWN = 'modern-dropdown-popup mc-dpr-datepicker-dropdown';
const SELECT_DROPDOWN = 'modern-dropdown-popup mc-dpr-modal-select-dd';

const GenerateReport = (props) => {
  const {
    isReportModalVisible,
    setIsReportModalVisible,
    setLocationData,
    locationData,
    projectIdValue,
    onGenerateReport,
    isLogReportsLoading,
    isWriteAccess,
  } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [location, setLocation] = useState('');
  const [format, setFormat] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);

  const [reportForm] = Form.useForm();

  const showModal = () => {
    setIsReportModalVisible(true);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      var userName = user['custom:first_name']
        ? user['custom:first_name'] +
          ' ' +
          (user['custom:last_name'] ? user['custom:last_name'] : '')
        : '';
      setName(userName);
      reportForm.setFieldsValue({ name: userName });
    }
  }, []);

  const handleOk = () => {
    reportForm.validateFields().then((data) => {
      if (!data.startDate && !data.endDate && !data.location && !data.email && !data.name) {
        notification.warning({
          message: 'Select All Required Fields to proceed!',
        });
      } else if (!data.startDate) {
        notification.warning({
          message: 'Select From Date to proceed!',
        });
      } else if (!data.endDate) {
        notification.warning({
          message: 'Select To Date to proceed!',
        });
      } else if (!data.location) {
        notification.warning({
          message: 'Select Location to proceed!',
        });
      } else if (!data.format) {
        notification.warning({
          message: 'Select Format to proceed!',
        });
      } else if (!data.email) {
        notification.warning({
          message: 'Provide Email to proceed!',
        });
      } else if (!data.name) {
        notification.warning({
          message: 'Provide Name to proceed!',
        });
      } else {
        var sowId = '';
        if (data.location && locationData) {
          locationData.filter((item) => {
            if (item.pipelineSection == data.location) {
              sowId = item.id;
            }
          });
        }
        var fromDate = moment(data.startDate).format('YYYY-MM-DD');
        var toDate = moment(data.endDate).format('YYYY-MM-DD');
        var obj = {
          fromDate: fromDate,
          toDate: toDate,
          sowId: sowId,
          format: data.format,
          email: data.email,
          generatedBy: data.name,
          projectId: projectIdValue,
          generateReport: true,
        };
        if (fromDate > toDate) {
          notification.warn({
            message: 'From date should be previous than To date',
          });
        } else {
          onGenerateReport(obj);
          reportForm.resetFields();
          setLoadingReport(true);
        }
      }
    });
  };

  useEffect(() => {
    if (!isLogReportsLoading) {
      setLoadingReport(false);
      setIsReportModalVisible(false);
      setStartDate(null);
      setEndDate(null);
      setLocation('');
      setEmail('');
      setName('');
    }
  }, [isLogReportsLoading]);

  const handleCancel = () => {
    reportForm.resetFields();
    setIsReportModalVisible(false);
    setStartDate(null);
    setEndDate(null);
    setLocation('');
    setEmail('');
    setName('');
  };

  return (
    <>
      <CrceButton
        label="Generate Report"
        variant="primary"
        size="small"
        onClick={() => {
          if (!isWriteAccess) showModal();
        }}
        disabled={isWriteAccess}
      />
      <Modal
        width="min(92vw, 640px)"
        className="modern-create-project-modal modern-dsr-dt-add-modal modern-generate-report-modal"
        wrapClassName="modern-dsr-dt-add-modal__wrap"
        title={<h3 className="modern-dsr-dt-add-modal__h-title">Generate Report</h3>}
        closeIcon={(
          <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
            <X size={20} strokeWidth={2} />
          </span>
        )}
        centered
        visible={isReportModalVisible}
        maskClosable={!isLogReportsLoading}
        maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
        onCancel={handleCancel}
        destroyOnClose
        footer={(
          <div
            className="modern-dsr-dt-add-modal__foot"
            role="group"
            aria-label="Generate report actions"
          >
            <CrceButton
              label="Discard"
              variant="tertiary"
              size="medium"
              onClick={handleCancel}
              disabled={isLogReportsLoading}
            />
            <CrceButton
              label={isLogReportsLoading ? 'Confirm…' : 'Confirm'}
              variant="primary"
              size="medium"
              onClick={handleOk}
              disabled={isLogReportsLoading}
            />
          </div>
        )}
      >
        <div className="modern-dsr-tech-log-section modern-dsr-dt-add-modal__form-scope">
          <span className="generate-report-section-label">Date range</span>
          <Form
            form={reportForm}
            className="modern-dsr-dt-add-modal__form"
            name="generate-report"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={16}>
              <Col lg={8}>
                <Form.Item
                  className="date-picker"
                  label="From"
                  name="startDate"
                  required
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    dropdownClassName={DATE_DROPDOWN}
                    getPopupContainer={getPopupContainerBody}
                    onChange={(date, dateString) => {
                      setStartDate(dateString);
                      if (endDate && dateString > endDate) {
                        notification.warn({
                          message: 'From date should be previous than To date',
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  className="date-picker"
                  label="To"
                  name="endDate"
                  required
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    dropdownClassName={DATE_DROPDOWN}
                    getPopupContainer={getPopupContainerBody}
                    onChange={(date, dateString) => setEndDate(dateString)}
                    disabledDate={(current) =>
                      startDate && current < moment(startDate, 'DD-MM-YYYY')
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg={16}>
                <Form.Item
                  label="Location"
                  name="location"
                  required
                >
                  <Select
                    className="client-select"
                    placeholder="Select Location"
                    dropdownClassName={SELECT_DROPDOWN}
                    getPopupContainer={getPopupContainerBody}
                    onChange={(value) => setLocation(value)}
                    value={location}
                  >
                    {locationData &&
                      locationData.map((item, i) => (
                        <Option
                          key={i}
                          value={item && item.pipelineSection}
                        >
                          {item && item.pipelineSection}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Form.Item
                  label="Format"
                  name="format"
                  required
                  className="report-radio"
                >
                  <Radio.Group
                    onChange={(e) => {
                      setFormat(e.target.value);
                    }}
                    value={format}
                  >
                    <Radio value={'CSV'}>CSV</Radio>
                    <Radio value={'PDF'}>PDF</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col
                lg={16}
                style={{ marginBottom: '24px' }}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  required
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    placeholder="Enter emails followed by comma (,)"
                  />
                </Form.Item>
                <span className="generate-report-hint">
                  eg: 1234@mail.com, 234@email.com
                </span>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col lg={16}>
                <Form.Item
                  label="Generated By"
                  name="name"
                  required
                >
                  <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    size="large"
                    placeholder="Name or Email"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default GenerateReport;
